<template>
  <div class="mb35 p20 brdr-1 brdr-cl-primary bg-cl-white" style="border-radius: 30px;" v-if="complaint">
    <!-- My complaint header -->
    <div class="row mb15">
      <div class="col-xs-12 col-md-2 col-lg-1">
        <return-icon class="p12 icon pointer" />
      </div>
      <div class="col-xs-12 col-md-6">
        <h3 class="m0 mb5 mt5">
          {{ $t('Complaint ') }} {{ complaint.rma_number ? complaint.rma_number : complaint.id }}
          <!-- 
          <span class="brdr-1 brdr-cl-bg-secondary py5 px10 ml20 sans-serif fs-medium-small weight-400 cl-secondary">
            {{ complaint.status | capitalize }}
          </span>
          -->
        </h3>
      </div>
    </div>
    <!-- My complaint body -->
    <div class="row fs16 mb10">
      <div class="col-xs-6 h4">
        <p>{{ $t('Create date') }}: {{ complaint.created | date('LLL', storeView) }}</p>
      </div>
      <div class="col-xs-6 h4">
        <p>{{ $t('Created by') }}: {{ complaint.name }}</p>
      </div>
    </div>
    <div class="row fs16 mb10">
      <div class="col-xs-6 h4">
        <p>{{ $t('RMA ') }}: {{ getRMAType(complaint.rma_type) }}</p>
      </div>
      <div class="col-xs-6 h4">
        <p>{{ $t('Status') }}: {{ complaint.status | capitalize}}</p>
      </div>
    </div>
    <div class="row fs16 mb10">
      <div class="col-xs-12 h4">
        <p>{{ $t('Description') }}: {{ complaint.description }}</p>
      </div>
    </div>
    <div class="row fs16 mb35">
      <div v-if="complaint.rma_type === 'service'"/>      
      <div v-else class="col-xs-12 h4">
        <h4>{{ $t('Complaint items') }}</h4>
        <table class="brdr-1 brdr-cl-bg-secondary">
          <thead>
            <tr>
              <th class="sans-serif lh20">
                {{ $t('BP model') }}
              </th>
              <th class="sans-serif lh20">
                {{ complaint.rma_type === 'RMA_Zwrot' || complaint.rma_type === 'Zwrot' ? $t('Qty') : $t('Printer') }}
              </th>
              <th class="sans-serif lh20">
                {{ complaint.rma_type === 'RMA_Zwrot' || complaint.rma_type === 'Zwrot' ? $t('Invoice') : $t('Reason') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="brdr-top-1 brdr-cl-bg-secondary" v-for="item in complaint.items" :key="item.sku">
              <td class="fs-medium lh25" :data-th="$t('SKU')">
                {{ item.part_number }}
              </td>
              <td class="fs-medium lh25" :data-th="$t('Qty')">
                {{ complaint.rma_type === 'RMA_Zwrot' || complaint.rma_type === 'Zwrot' ? item.quantity : item.device }}
              </td>
              <td class="fs-medium lh25" :data-th="$t('Reason')">
                {{ complaint.rma_type === 'RMA_Zwrot' || complaint.rma_type === 'Zwrot' ? item.invoice : item.reason }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="brdr-top-1 brdr-cl-bg-secondary">
              <td colspan="5" class="align-right">
                
              </td>
              <td> </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="row fs16 mb35">
      <div class="col-xs-2">        
        <complaint-pdf :currentComplaint="complaint" />
         <button-full 
            type="button"                 
            @click.native="$bus.$emit('download-pdf')"
          >
          {{ $t('Download PDF') }}            
        </button-full>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import { Logger } from '@vue-storefront/core/lib/logger'
import ReturnIcon from 'theme/components/core/blocks/Header/ReturnIcon'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import ComplaintPdf from 'theme/components/core/blocks/MyAccount/ComplaintPdf'
import ButtonFull from 'theme/components/theme/ButtonFull.vue'
export default {
  mixins: [],
  components: {
    ReturnIcon,
    ComplaintPdf,
    "button-full": ButtonFull
  },
  data () {
    return {
       complaint: {}
    }
  },
  computed: {
    storeView () {
      return currentStoreView()
    },
  },
  methods: {
    ...mapActions({
       
    }),
    getRMAType (type) {
      if (type == 'RMA_KlientD2D') {
        return 'Door To Door'
      } else if (type == 'RMA_Zwrot') {
        return 'Zwrot'
      } else if (type == 'service') {
        return 'Dom i biuro'
      }else {
        return type
      }
    }
  },
  async beforeCreate () {
    const id = this.$route.params.complaintId;
    const uid = this.$store.state.user.token;
    const details = await this.$store.dispatch('user/getComplaintDetails', { complaintId: id });
    this.complaint = details;
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-tertiary: color(tertiary);
$color-white-smoke: color(white-smoke);

table {
  border-collapse: collapse;
  width: 100%;

  @media (max-width: 767px) {
    border-top: none;
  }

  th, td {
    text-align: left;
    padding: 20px;

    &.align-right {
      text-align: right;

      @media (max-width: 767px) {
        text-align: left;
      }

    }

    @media (max-width: 1199px) {
      padding: 10px;
    }

  }

  thead {
    @media (max-width: 767px) {
      display: none;
    }
  }

  tbody {

    tr {
      @media (max-width: 767px) {
        display: block
      }

      &:nth-child(even) {
        td {
          background-color: $color-white-smoke;
        }
      }

    }

    td {
      @media (max-width: 767px) {
        display: block;
        text-align: left;
        padding: 10px 20px;
        &:before {
          content: attr(data-th) ': ';
          font-weight: 700;
        }
      }

      &:first-child {
        @media (max-width: 767px) {
          padding: 20px 20px 10px 20px;
        }
      }

      &:last-child {
        @media (max-width: 767px) {
          padding: 10px 20px 20px 20px;
        }
      }
    }

  }

  tfoot {

    tr {
      @media (max-width: 767px) {
        display: block
      }

      &:last-child {
        td:last-child {
         padding-bottom: 20px
        }
      }

    }

    td {
      @media (max-width: 767px) {
        display: block
      }

      &:first-child {
        @media (max-width: 767px) {
          font-weight: 700;
          padding: 20px 20px 5px 20px;
        }
      }

      &:last-child {
        @media (max-width: 767px) {
          padding: 5px 20px 0 20px;
        }
      }

    }

  }

  i {
    vertical-align: middle;
  }

}

a {
  &:after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: $color-tertiary;
  }

  &:hover {
    &:after {
      opacity: 0;
    }
  }
}

address {
  font-style: normal;
}
</style>
